/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * The subset of fields a household family member may see about themselves on the public site.
 * @export
 * @interface WebApiPublicSiteDtoGetFamilyMemberSelfResultDto
 */
export interface WebApiPublicSiteDtoGetFamilyMemberSelfResultDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoGetFamilyMemberSelfResultDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoGetFamilyMemberSelfResultDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoGetFamilyMemberSelfResultDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoGetFamilyMemberSelfResultDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiPublicSiteDtoGetFamilyMemberSelfResultDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoGetFamilyMemberSelfResultDto interface.
 */
export function instanceOfWebApiPublicSiteDtoGetFamilyMemberSelfResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoFromJSON(json: any): WebApiPublicSiteDtoGetFamilyMemberSelfResultDto {
    return WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoGetFamilyMemberSelfResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
    };
}

export function WebApiPublicSiteDtoGetFamilyMemberSelfResultDtoToJSON(value?: WebApiPublicSiteDtoGetFamilyMemberSelfResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
    };
}

